import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { TransactionTypesService } from '../transaction-types.service';

@Component({
  selector: 'app-transaction-types-detail',
  templateUrl: './transaction-types-detail.component.html',
  styleUrls: ['./transaction-types-detail.component.scss']
})
export class TransactionTypesDetailComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  public transactionType: any = {}
  public lastGridEvent: any;
  constructor(
    private transactionsTypesService: TransactionTypesService,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dialogService: DialogService,
    private coreDialogService: CoreDialogService,
    private dynamicDialogRef: DynamicDialogRef
  ) { }

  ngOnInit(): void {
    this.loadData(this.config.data.id);
  }
  loadData(id){
    if(id){
      this.transactionsTypesService.get(id).subscribe(
        data=>{
          this.transactionType = data;
        },
        error =>{
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }
  save(event:any) {
    if (typeof this.transactionType.id === "undefined") {
      this.transactionsTypesService.add(this.transactionType).subscribe(
        data => {
          this.transactionType = data;
          this.loadData(this.transactionType.id);
          this.messageService.add({ closable: false, severity: 'success', summary: "Tipo de transacción añadido correctamente." });
          location.reload();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.transactionsTypesService.save(this.transactionType.id, this.transactionType).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Tipo de transacción guardado correctamente" });
          location.reload();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el tipo de transacción " + this.transactionType.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.transactionsTypesService.delete(this.transactionType.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.dynamicDialogRef.close();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }
  isDuplied(event) {
    if(!event.valid){
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    this.transactionsTypesService.isDuplied(this.transactionType).subscribe(
      data => {
        if(data == true){
          this.coreDialogService.notify({
            message:  "Ya existe un tipo de transacción con estos datos proporcionados." ,
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });          
        }else{
          this.save(event);
        }
      }
    );
  }
  onEvent(event) {
    if (event.component == "transactionTypes.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.isDuplied(event);
    }
    if (event.component == "view" && event.event == "entity-loaded") {
      this.config.header = typeof (this.transactionType.id) !== "undefined" ? "Detalles del " + this.view.getEntityBaseName() : "Nuevo " + this.view.getEntityBaseName();
    }
  }
}
